module.exports = __webpack_public_path__ + "media/images/partners/3_ukr_atelier-c8af51cc264bdab2839eb00bcbbb8e30.png";